import React, { Suspense, Fragment, lazy } from 'react';
import { Switch, Redirect, Route } from 'react-router-dom';

import Loader from './components/Loader/Loader';
import AdminLayout from './layouts/AdminLayout';

// import GuestGuard from './components/Auth/GuestGuard';
// import AuthGuard from './components/Auth/AuthGuard';

import { BASE_URL } from './config/constant';

export const renderRoutes = (routes = []) => (
  <Suspense fallback={<Loader />}>
    <Switch>
      {routes.map((route, i) => {
        const Guard = route.guard || Fragment;
        const Layout = route.layout || Fragment;
        const Component = route.component;

        return (
          <Route
            key={i}
            path={route.path}
            exact={route.exact}
            render={(props) => (
              <Guard>
                <Layout>{route.routes ? renderRoutes(route.routes) : <Component {...props} />}</Layout>
              </Guard>
            )}
          />
        );
      })}
    </Switch>
  </Suspense>
);

const routes = [
  {
    exact: true,
    path: '/',
    component: lazy(() => import('./views/auth/signin/SignIn1'))
  },
  {
    exact: true,
    // guard: GuestGuard,
    path: '/upschool',
    component: lazy(() => import('./views/auth/signin/SignIn1'))
  },
  {
    exact: true,
    // guard: GuestGuard,
    path: '/auth/signin-1',
    component: lazy(() => import('./views/auth/signin/SignIn1'))
  },
  // {
  //   exact: true,
  //   // guard: GuestGuard,
  //   path: '/auth/landingPage/:teacher_id',
  //   component: lazy(() => import('./views/panels/teacher-portal/LandingPage/Landing'))
  // },
  {
    exact: true,
    // guard: GuestGuard,
    path: '/auth/landingPage/:teacher_id',
    component: lazy(() => import('./views/panels/teacher-portal/LandingPage/LandingPage'))
  },
  {
    exact: true,
    // guard: GuestGuard,
    path: '/auth/loginWithOTP',
    component: lazy(() => import('./views/auth/signin/LoginWithOTP'))
  },
  {
    exact: true,
    // guard: GuestGuard,
    path: '/auth/createOrResetPassword',
    component: lazy(() => import('./views/auth/signin/CreateOrResetPassword'))
  },
  {
    exact: true,
    path: '/404',
    component: lazy(() => import('./views/errors/NotFound404'))
  },
  {
    exact: true,
    path: '/maintenance/coming-soon',
    component: lazy(() => import('./views/maintenance/ComingSoon'))
  },
  {
    exact: true,
    path: '/maintenance/error',
    component: lazy(() => import('./views/maintenance/Error'))
  },
  {
    exact: true,
    path: '/maintenance/offline-ui',
    component: lazy(() => import('./views/maintenance/OfflineUI'))
  },
  {
    exact: true,
    path: '/admin-portal/test-question-preview/:question_paper_id',
    component: lazy(() => import('./views/panels/teacher-portal/TestQuestionPapers/QuestionPaperPreview'))
  },
  // {
  //   exact: true,
  //   path: '/auth/signup-1',
  //   component: lazy(() => import('./views/auth/signup/SignUp1'))
  // },
  // {
  //   exact: true,
  //   path: '/auth/signup-2',
  //   component: lazy(() => import('./views/auth/signup/SignUp2'))
  // },
  // {
  //   exact: true,
  //   path: '/auth/signin-2',
  //   component: lazy(() => import('./views/auth/signin/SignIn2'))
  // },
  // {
  //   exact: true,
  //   path: '/auth/reset-password-1',
  //   component: lazy(() => import('./views/auth/reset-password/ResetPassword1'))
  // },
  // {
  //   exact: true,
  //   path: '/auth/reset-password-2',
  //   component: lazy(() => import('./views/auth/reset-password/ResetPassword2'))
  // },
  // {
  //   exact: true,
  //   path: '/auth/change-password',
  //   component: lazy(() => import('./views/auth/ChangePassword'))
  // },
  {
    exact: true,
    path: '/auth/profile-settings',
    component: lazy(() => import('./views/auth/ProfileSettings'))
  },
  
  {
    exact: true,
    path: '/auth/tabs-auth',
    component: lazy(() => import('./views/auth/TabsAuth'))
  },

  {
    exact: true,
    path: '/teacher-portal/scanner/generateOTP/:school_id/:teacher_id/:test_id/:client_class_id/:section_id/:test_type',
    component: lazy(() => import('./views/panels/teacher-portal/Scanner/Generateotp'))
  },
  {
    exact: true,
    path: '/teacher-portal/scanner/:school_id/:teacher_id/:test_id/:client_class_id/:section_id/:test_type',
    component: lazy(() => import('./views/panels/teacher-portal/Scanner/Scanner.js'))
  },

//phase 2 routes





  // ${client_class_id}/${section_id}/${subject_id}
  {
    path: '*',
    layout: AdminLayout,
    routes: [

      {
        exact: true,
        path: '/admin-portal/active-schools',
        component: lazy(() => import('./views/panels/admin-portal/school/FetchActiveSchools'))
      },
      {
        exact: true,
        path: '/admin-portal/edit-timeTable/:section_ids',
        component: lazy(() => import('./views/panels/admin-portal/school/TimeTableConfiguration'))
      },
      {
        exact: true,
        path: '/teacher-portal/active-users',
        component: lazy(() =>
          import('./views/panels/teacher-portal/users/ListUsers')
    
        )
      },
      {
        exact: true,
        path: '/teacher-portal/archived-users',
        component: lazy(() => import('./views/panels/teacher-portal/users/ListUsers')

        )
      },
      {
        exact: true,
        path: '/teacher-portal/add-users/',
        component: lazy(() => import('./views/panels/teacher-portal/users/UsersBulkUpload'))
      },
      {
        exact: true,
        path: '/teacher-portal/editSchool',
        component: lazy(() => import('./views/panels/admin-portal/school/EditTabs'))
      },
      {
        exact: true,
        path: '/teacher-portal/edit-users/:user_id/:user_role/:schoolId',
        component: lazy(() => import('./views/panels/teacher-portal/users/EditUserOptions'))
      },





      {
        exact: true,
        path: `/app/dashboard/analytics/:client_class_id/:section_id/:subject_id/:teacher_id`,
        component: lazy(() => import('./views/dashboard/DashAnalytics'))
      },

      {
        exact: true,
        path: '/teacher-portal/dashboard',
        component: lazy(() => import('./appliction/containers/Dashboard'))

      },
      // {
      //   exact: true,
      //   path: '/teacher-portal/dashboard',
      //   component: lazy(() => import('./appliction/containers/Dashboard'))

      // },
      {
        exact: true,
        path: '/teacher-portal/syllabus',
        component: lazy(() => import('./views/panels/teacher-portal/Syllabus/Syllabus'))
      },
      {
        exact: true,
        path: '/teacher-portal/student',
        component: lazy(() => import('./appliction/containers/Student'))
      },
      {
        exact: true,
        path: '/teacher-portal/student/chapter-details',
        component: lazy(() => import('./views/panels/student-portal/ChapterDetails'))
      },
      {
        exact: true,
        path: '/teacher-portal/student/custom-worksheet',
        component: lazy(() => import('./views/panels/student-portal/CustomWorksheetGen'))
      },
      {
        exact: true,
        path: '/teacher-portal/active-question-papers',
        component: lazy(() => import('./views/panels/teacher-portal/TestQuestionPapers/QuestionPapersTableView'))
      },
      {
        exact: true,
        path: '/teacher-portal/archived-question-papers',
        component: lazy(() => import('./views/panels/teacher-portal/TestQuestionPapers/QuestionPapersTableView'))
      },
      {
        exact: true,
        path: '/teacher-portal/select-blue-print-template',
        component: lazy(() => import('./views/panels/teacher-portal/TestQuestionPapers/BluePrintTemplate'))
      },
      {
        exact: true,
        path: '/teacher-portal/select-worksheet-blue-print-template',
        component: lazy(() => import('./views/panels/teacher-portal/TestQuestionPapers/BluePrintTemplate'))
      },
      {
        exact: true,
        path: '/teacher-portal/question-paper-details',
        component: lazy(() => import('./views/panels/teacher-portal/TestQuestionPapers/CombinedPages'))
      },
      {
        exact: true,
        path: '/teacher-portal/edit-question-paper',
        component: lazy(() => import('./views/panels/teacher-portal/TestQuestionPapers/EditQuestionPaper'))
      },
      {
        exact: true,
        path: '/teacher-portal/syllabus/generatePreQuiz',
        component: lazy(() => import('./views/panels/teacher-portal/Topic/GeneratePreQuiz'))
      },
      {
        exact: true,
        path: '/teacher-portal/syllabus/generatePostQuiz/:selectedTopics',
        component: lazy(() => import('./views/panels/teacher-portal/Topic/GeneratePostQuiz'))
      },
      {
        exact: true,
        path: '/teacher-portal/syllabus/generatePostQuiz/quizDuration/:selectedTopics',
        component: lazy(() => import('./views/panels/teacher-portal/Topic/QuizDuration'))
      },

      {
        exact: true,
        // guard: GuestGuard,
        path: '/teacher-portal/syllabus/chapter-table/:chapter_id',
        component: lazy(() => import('./views/panels/teacher-portal/Topic/TopicListTabs'))
      },
      {
        exact: true,
        path: '/teacher-portal/change-password',
        component: lazy(() => import('./views/profile/ChangePassword'))
      },
      {
        exact: true,
        path: '/app/dashboard/analytics',
        component: lazy(() => import('./views/dashboard/DashAnalytics'))
      },
      //DigicardList
      {
        exact: true,
        path: '/teacher-portal/digicard/digicardList/:topic_id',
        component: lazy(() => import('./views/panels/teacher-portal/Digicard/ActiveDigicardList'))
      },
      //DigicardTable
      {
        exact: true,
        path: '/teacher-portal/syllabus/digicardTeacherView/:topic_id',
        component: lazy(() => import('./views/panels/teacher-portal/Digicard/DigicardsTable'))
      },
      //DigicardFiles
      {
        exact: true,
        path: '/teacher-portal/syllabus/digicard/attachFiles/:digicard_id',
        component: lazy(() => import('./views/panels/teacher-portal/Digicard/DigicardFiles'))
      },
      //Unlock Pre Topic Digicard
      {
        exact: true,
        path: '/teacher-portal/syllabus/unlockDigicard:chapter_id',
        component: lazy(() => import('./views/panels/teacher-portal/Digicard/UnlockPreTopicDigicard'))
      },
      //Unlock Post Topic Digicard
      {
        exact: true,
        path: '/teacher-portal/digicard/unlockPostTopicDigicard/:chapter_id',
        component: lazy(() => import('./views/panels/teacher-portal/Digicard/UnlockPostTopicDigicard'))
      },
      //View digicard content
      {
        exact: true,
        path: '/teacher-portal/digicard/digicardPreview/:digicard_id',
        component: lazy(() => import('./views/panels/teacher-portal/Digicard/Digicard'))
      },
      //Arrage Digicards
      {
        exact: true,
        path: '/teacher-portal/digicard/arrageDigicards/:topic_id',
        component: lazy(() => import('./views/panels/teacher-portal/Digicard/ArrangeDigicard'))
      },
      // question MetaData
      {
        exact: true,
        path: '/teacher-portal/questionPaper/questionDetails',
        component: lazy(() => import('./views/panels/teacher-portal/TestQuestionPapers/CombinedPages'))
      },
      {
        exact: true,
        path: '/teacher-portal/questionPaper/worksheet-questionDetails',
        component: lazy(() => import('./views/panels/teacher-portal/TestQuestionPapers/CombinedPages'))
      },
      //preview screen page
      {
        exact: true,
        path: '/teacher-portal/paper-previewScreen/:question_paper_id',
        component: lazy(() => import('./views/panels/teacher-portal/TestQuestionPapers/QuestionPaperPreview'))
      },
      //TestScheduleList
      {
        exact: true,
        path: '/teacher-portal/active-test-schedule',
        component: lazy(() => import('./views/panels/teacher-portal/TestSchedule/TestScheduleListTable'))
      },
      //AddTestSchedule
      {
        exact: true,
        path: '/teacher-portal/add-test-schedule',
        component: lazy(() => import('./views/panels/teacher-portal/TestSchedule/AddTestSchedule'))
      },
      {
        exact: true,
        path: '/teacher-portal/archived-test-schedule',
        component: lazy(() => import('./views/panels/teacher-portal/TestSchedule/TestScheduleListTable'))
      },
      //worksheet
      {
        exact: true,
        path: '/teacher-portal/active-worksheet',
        component: lazy(() => import('./views/panels/teacher-portal/WorkSheets/WorkSheetListTable'))
      },
      //AddTestSchedule
      {
        exact: true,
        path: '/teacher-portal/add-worksheet',
        component: lazy(() => import('./views/panels/teacher-portal/WorkSheets/AddWorkSheet'))
      },
      {
        exact: true,
        path: '/teacher-portal/archived-worksheet',
        component: lazy(() => import('./views/panels/teacher-portal/WorkSheets/WorkSheetListTable'))
      },
      {
        exact: true,
        path: '/teacher-portal/teacherSessions',
        component: lazy(() => import('./views/panels/teacher-portal/teacherSessions/TeacherSessions'))
      },
      {
        exact: true,
        path: '/teacher-portal/SessionDetails',
        component: lazy(() => import('./views/panels/teacher-portal/teacherSessions/SessionDetails'))
      },
      
      {
        exact: true,
        path: '/teacher-portal/learning-expectation-cointainer',
        component: lazy(() => import('./components/Phase2/targtdLearngExpectn/LearngExpectnCointainer'))
      },
      {
        exact: true,
        path: '/teacher-portal/curriculum-planner',
        component: lazy(() => import('./views/CurriculumPlanner/CurriculumPlanner'))
      },
      {
        exact: true,
        // path: '/teacher-portal/pre-learning-blueprint/:chapter_id',
        path: '/teacher-portal/pre-learning-blueprint',
        component: lazy(() => import('./components/Phase2/blueprintLearngPgs/PreLearningBlueprint'))
      },
      {
        exact: true,
        // path: '/teacher-portal/pre-learning-blueprint/:chapter_id',
        path: '/teacher-portal/post-learning-blueprint',
        component: lazy(() => import('./components/Phase2/blueprintLearngPgs/PreLearningBlueprint'))
      },
      {
        exact: true,
        path: '/teacher-portal/assesment-Summary/IndividualReport',
        component: lazy(() => import('./components/Phase2/individualReport/IndividualReport'))
      },
      {
        exact: true,
        path: '/teacher-portal/IndividualReport/viewAnalysis',
        component: lazy(() => import('./components/Phase2/individualReport/viewAnalysis'))
      },
      {
        exact: true,
        path: '/teacher-portal/ActionsAndreCommendations/ActionItems',
        component: lazy(() => import('./components/Phase2/actionsandrecommendations/ActionItems'))
      },
      {
        exact: true,
        path: '/teacher-portal/ActionsAndreCommendations/ClassScoredBelowThreshould/:quiz_id/:concept',
        component: lazy(() => import('./components/Phase2/actionsandrecommendations/ClassScoredBelowThreshould'))
      },
      // {
      //   exact: true,
      //   path: '/teacher-portal/post-learning-blueprint',
      //   component: lazy(() => import('./components/Phase2/blueprintLearngPgs/PostLearningBlueprint'))
      // },
      {
        exact: true,
        path: '/teacher-portal/assesment-Summary/postLearning',
        component: lazy(() => import('./components/Phase2/assesmentSummary/PostLearningTopic'))
      },
      {
        exact: true,
        path: '/teacher-portal/assesment-Summary/:type',
        component: lazy(() => import('./components/Phase2/assesmentSummary/PreLearningTopic'))
      },
      {
        exact: true,
        path: '/teacher-portal/class-report-container',
        component: lazy(() => import('./components/Widgets/Statistic/classReport/ClassReportContainer.js'))
      },
      //viewResult
      // {
      //   exact: true,
      //   path: '/teacher-portal/view-result',
      //   component: lazy(() => import('./views/panels/teacher-portal/TestSchedule/ViewResult'))
      // },

      {
        exact: true,
        path: '/teacher-portal/view-result-tab',
        component: lazy(() => import('./views/panels/teacher-portal/TestSchedule/ResultTabs'))
      },
      //

      {
        exact: true,
        // guard: GuestGuard,
        path: '/teacher-portal/view-test-result/:class_test_id',
        component: lazy(() => import('./views/panels/teacher-portal/TestSchedule/PreEvaluation'))
      },
      {
        exact: true,
        // guard: GuestGuard,
        path: '/teacher-portal/test/:class_test_id',
        component: lazy(() => import('./views/panels/teacher-portal/TestSchedule/TestTabs'))
      },
      {
        exact: true,
        // guard: GuestGuard,
        path: '/teacher-portal/blueprint',
        component: lazy(() => import('./views/panels/teacher-portal/TestSchedule/BlueprintTabs'))
      },
      {
        exact: true,
        // guard: GuestGuard,
        path: '/teacher-portal/quiz/:quiz_id',
        component: lazy(() => import('./views/panels/teacher-portal/QuizSchedule/TestTabs'))
      },
      //studentResultView
      {
        exact: true,
        path: '/teacher-portal/test-student-result/:student_id',
        component: lazy(() => import('./views/panels/teacher-portal/TestSchedule/ViewResult'))
      },
      {
        exact: true,
        path: '/teacher-portal/quiz-student-result/:student_id',
        component: lazy(() => import('./views/panels/teacher-portal/QuizSchedule/ViewResult'))
      },
      {
        exact: true,
        path: '/app/dashboard/sales',
        component: lazy(() => import('./views/dashboard/DashSales'))
      },
      {
        exact: true,
        path: '/app/widgets/widget-statistic',
        component: lazy(() => import('./views/widgets/WidgetStatistic'))
      },
      {
        exact: true,
        path: '/app/widgets/widget-data',
        component: lazy(() => import('./views/widgets/WidgetData'))
      },
      {
        exact: true,
        path: '/app/widgets/widget-chart',
        component: lazy(() => import('./views/widgets/WidgetChart'))
      },
      {
        exact: true,
        path: '/layout/vertical/static',
        component: lazy(() => import('./views/page-layouts/vertical/Static'))
      },
      {
        exact: true,
        path: '/layout/vertical/fixed',
        component: lazy(() => import('./views/page-layouts/vertical/Fixed'))
      },
      {
        exact: true,
        path: '/layout/vertical/nav-fixed',
        component: lazy(() => import('./views/page-layouts/vertical/NavFixed'))
      },
      {
        exact: true,
        path: '/layout/vertical/collapse-menu',
        component: lazy(() => import('./views/page-layouts/vertical/CollapseMenu'))
      },
      {
        exact: true,
        path: '/layout/vertical/v-rtl',
        component: lazy(() => import('./views/page-layouts/vertical/RTLLayout'))
      },
      {
        exact: true,
        path: '/layout/horizontal',
        component: lazy(() => import('./views/page-layouts/horizontal/Static'))
      },
      {
        exact: true,
        path: '/layout/horizontal-v2',
        component: lazy(() => import('./views/page-layouts/horizontal/Static-v2'))
      },
      {
        exact: true,
        path: '/layout/horizontal-rtl',
        component: lazy(() => import('./views/page-layouts/horizontal/RTLLayout'))
      },
      {
        exact: true,
        path: '/layout/box',
        component: lazy(() => import('./views/page-layouts/extra-layouts/Box'))
      },
      {
        exact: true,
        path: '/layout/light',
        component: lazy(() => import('./views/page-layouts/extra-layouts/Light'))
      },
      {
        exact: true,
        path: '/layout/dark',
        component: lazy(() => import('./views/page-layouts/extra-layouts/Dark'))
      },
      {
        exact: true,
        path: '/users/user-profile',
        component: lazy(() => import('./views/users/UserProfile'))
      },
      {
        exact: true,
        path: '/users/user-cards',
        component: lazy(() => import('./views/users/UserCard'))
      },
      {
        exact: true,
        path: '/users/user-list',
        component: lazy(() => import('./views/users/UserList'))
      },
      {
        exact: true,
        path: '/basic/alert',
        component: lazy(() => import('./views/ui-elements/basic/BasicAlert'))
      },
      {
        exact: true,
        path: '/basic/button',
        component: lazy(() => import('./views/ui-elements/basic/BasicButton'))
      },
      {
        exact: true,
        path: '/basic/badges',
        component: lazy(() => import('./views/ui-elements/basic/BasicBadges'))
      },
      {
        exact: true,
        path: '/basic/breadcrumb-pagination',
        component: lazy(() => import('./views/ui-elements/basic/BasicBreadcrumbPagination'))
      },
      {
        exact: true,
        path: '/basic/cards',
        component: lazy(() => import('./views/ui-elements/basic/BasicCards'))
      },
      {
        exact: true,
        path: '/basic/collapse',
        component: lazy(() => import('./views/ui-elements/basic/BasicCollapse'))
      },
      {
        exact: true,
        path: '/basic/carousel',
        component: lazy(() => import('./views/ui-elements/basic/BasicCarousels'))
      },
      {
        exact: true,
        path: '/basic/grid-system',
        component: lazy(() => import('./views/ui-elements/basic/BasicGridSystem'))
      },
      {
        exact: true,
        path: '/basic/progress',
        component: lazy(() => import('./views/ui-elements/basic/BasicProgress'))
      },
      {
        exact: true,
        path: '/basic/modal',
        component: lazy(() => import('./views/ui-elements/basic/BasicModals'))
      },
      {
        exact: true,
        path: '/basic/spinner',
        component: lazy(() => import('./views/ui-elements/basic/BasicSpinner'))
      },
      {
        exact: true,
        path: '/basic/tabs-pills',
        component: lazy(() => import('./views/ui-elements/basic/BasicTabsPills'))
      },
      {
        exact: true,
        path: '/basic/typography',
        component: lazy(() => import('./views/ui-elements/basic/BasicTypography'))
      },
      {
        exact: true,
        path: '/basic/tooltip-popovers',
        component: lazy(() => import('./views/ui-elements/basic/BasicTooltipsPopovers'))
      },
      {
        exact: true,
        path: '/basic/other',
        component: lazy(() => import('./views/ui-elements/basic/BasicOther'))
      },


      {
        exact: true,
        path: '/advance/sweet-alert',
        component: lazy(() => import('./views/ui-elements/advance/AdvanceAlert'))
      },
      {
        exact: true,
        path: '/advance/datepicker',
        component: lazy(() => import('./views/ui-elements/advance/AdvanceDatepicker'))
      },
      {
        exact: true,
        path: '/advance/task-board',
        component: lazy(() => import('./views/ui-elements/advance/AdvanceTaskBoard'))
      },
      {
        exact: true,
        path: '/advance/light-box',
        component: lazy(() => import('./views/ui-elements/advance/AdvanceLightBox'))
      },
      {
        exact: true,
        path: '/advance/adv-modal',
        component: lazy(() => import('./views/ui-elements/advance/AdvanceModal'))
      },
      {
        exact: true,
        path: '/advance/notification',
        component: lazy(() => import('./views/ui-elements/advance/AdvanceNotification'))
      },
      {
        exact: true,
        path: '/advance/nestable',
        component: lazy(() => import('./views/ui-elements/advance/AdvanceNestable'))
      },
      {
        exact: true,
        path: '/advance/p-notify',
        component: lazy(() => import('./views/ui-elements/advance/AdvancePNotify'))
      },
      {
        exact: true,
        path: '/advance/rating',
        component: lazy(() => import('./views/ui-elements/advance/AdvanceRating'))
      },
      {
        exact: true,
        path: '/advance/range-slider',
        component: lazy(() => import('./views/ui-elements/advance/AdvanceRangeSlider'))
      },
      {
        exact: true,
        path: '/advance/slider',
        component: lazy(() => import('./views/ui-elements/advance/AdvanceSlider'))
      },
      {
        exact: true,
        path: '/advance/syntax-highlighter',
        component: lazy(() => import('./views/ui-elements/advance/AdvanceSyntaxHighlighter'))
      },
      {
        exact: true,
        path: '/advance/tour',
        component: lazy(() => import('./views/ui-elements/advance/AdvanceTour'))
      },
      {
        exact: true,
        path: '/advance/tree-view',
        component: lazy(() => import('./views/ui-elements/advance/AdvanceTree'))
      },
      {
        exact: true,
        path: '/forms/form-basic',
        component: lazy(() => import('./views/forms/FormsElements'))
      },
      {
        exact: true,
        path: '/forms/form-advance',
        component: lazy(() => import('./views/forms/FormsAdvance'))
      },
      {
        exact: true,
        path: '/forms/form-validation',
        component: lazy(() => import('./views/forms/FormsValidation'))
      },
      {
        exact: true,
        path: '/forms/form-masking',
        component: lazy(() => import('./views/forms/FormsMasking'))
      },
      {
        exact: true,
        path: '/forms/form-wizard',
        component: lazy(() => import('./views/forms/FormsWizard'))
      },
      {
        exact: true,
        path: '/forms/form-picker',
        component: lazy(() => import('./views/forms/FormsPicker'))
      },
      {
        exact: true,
        path: '/forms/form-select',
        component: lazy(() => import('./views/forms/FormsSelect'))
      },
      {
        exact: true,
        path: '/tables/bootstrap',
        component: lazy(() => import('./views/tables/BootstrapTable'))
      },
      {
        exact: true,
        path: '/table/datatable/tbl-basic',
        component: lazy(() => import('./views/tables/react-table/Basic'))
      },
      {
        exact: true,
        path: '/table/datatable/tbl-footer',
        component: lazy(() => import('./views/tables/react-table/Footers'))
      },
      {
        exact: true,
        path: '/table/datatable/tbl-sorting',
        component: lazy(() => import('./views/tables/react-table/Sorting'))
      },
      {
        exact: true,
        path: '/table/datatable/tbl-filtering',
        component: lazy(() => import('./views/tables/react-table/Filtering'))
      },
      {
        exact: true,
        path: '/table/datatable/tbl-grouping',
        component: lazy(() => import('./views/tables/react-table/Grouping'))
      },
      {
        exact: true,
        path: '/table/datatable/tbl-pagination',
        component: lazy(() => import('./views/tables/react-table/Pagination'))
      },
      {
        exact: true,
        path: '/charts/apex-chart',
        component: lazy(() => import('./views/charts/apex-chart'))
      },
      {
        exact: true,
        path: '/charts/chart-js',
        component: lazy(() => import('./views/charts/chart-js'))
      },
      {
        exact: true,
        path: '/charts/highchart',
        component: lazy(() => import('./views/charts/highchart'))
      },
      {
        exact: true,
        path: '/charts/rechart',
        component: lazy(() => import('./views/charts/re-chart'))
      },
      {
        exact: true,
        path: '/maps/google-map',
        component: lazy(() => import('./views/maps/GoogleMaps'))
      },
      {
        exact: true,
        path: '/maps/vector-map',
        component: lazy(() => import('./views/maps/VectorMaps'))
      },
      {
        exact: true,
        path: '/todo/todo-basic',
        component: lazy(() => import('./views/applications/to-do/ToDo'))
      },
      {
        exact: true,
        path: '/task/task-list',
        component: lazy(() => import('./views/applications/task/TaskList'))
      },
      {
        exact: true,
        path: '/task/task-board',
        component: lazy(() => import('./views/applications/task/TaskBoard'))
      },
      {
        exact: true,
        path: '/task/task-detail',
        component: lazy(() => import('./views/applications/task/TaskDetails'))
      },
      {
        exact: true,
        path: '/gallery/gallery-grid',
        component: lazy(() => import('./views/applications/gallery/GalleryGrid'))
      },
      {
        exact: true,
        path: '/gallery/photo-grid',
        component: lazy(() => import('./views/applications/gallery/PhotoGrid'))
      },
      {
        exact: true,
        path: '/gallery/gallery-masonry',
        component: lazy(() => import('./views/applications/gallery/MasonryGallery'))
      },
      {
        exact: true,
        path: '/editor/ck-editor/ck-classic',
        component: lazy(() => import('./views/extensions/editors/ck-editor/EditorCkClassic'))
      },
      {
        exact: true,
        path: '/editor/ck-editor/ck-balloon',
        component: lazy(() => import('./views/extensions/editors/ck-editor/EditorCkBalloon'))
      },
      {
        exact: true,
        path: '/editor/ck-editor/ck-inline',
        component: lazy(() => import('./views/extensions/editors/ck-editor/EditorCkInline'))
      },
      {
        exact: true,
        path: '/editor/ck-editor/ck-document',
        component: lazy(() => import('./views/extensions/editors/ck-editor/EditorCkDocument'))
      },
      {
        exact: true,
        path: '/editor/rich-editor',
        component: lazy(() => import('./views/extensions/editors/EditorRichNib'))
      },
      {
        exact: true,
        path: '/editor/jodit-wysiwyg',
        component: lazy(() => import('./views/extensions/editors/EditorJoditWYSIWYG'))
      },
      {
        exact: true,
        path: '/image-cropper',
        component: lazy(() => import('./views/extensions/ImageCropper'))
      },
      {
        exact: true,
        path: '/file-upload',
        component: lazy(() => import('./views/extensions/FileUpload'))
      },
      {
        exact: true,
        path: '/full-calendar',
        component: lazy(() => import('./views/extensions/FullEventCalendar'))
      },
      {
        exact: true,
        path: '/invoice/invoice-basic',
        component: lazy(() => import('./views/extensions/invoice/InvoiceBasic'))
      },
      {
        exact: true,
        path: '/invoice/invoice-summary',
        component: lazy(() => import('./views/extensions/invoice/InvoiceSummary'))
      },
      {
        exact: true,
        path: '/invoice/invoice-list',
        component: lazy(() => import('./views/extensions/invoice/InvoiceList'))
      },
      {
        exact: true,
        path: '/sample-page',
        component: lazy(() => import('./views/extra/SamplePage'))
      },
    
      {
        path: '*',
        exact: true,
        component: () => <Redirect to={BASE_URL} />
      },



    ]
  }
];

export default routes;
